export default __webpack_public_path__ + "static/media/cropsGrains.dbed52a2.svg";